export const text = {
  header: "HAVE A QUESTION?",
  copy: "We are here for technical support or any questions you may have about our products and service.",
  contact: "Contact Us",
};
